import React from 'react';
import styles from './AdSavings.module.scss';
import {IProduct} from 'data/interfaces/products';
import {extractProductOriginalPrice} from 'data/redux/selectors/productSelector';
import {Else, If, Then} from 'react-if';
import percentage from 'calculate-percentages'
import {currencyValueToLabel} from 'gui/components/formikCurrencySelector';

export enum eSavingsType {
  PERCENTAGE = 1,
  NUMBER = 2
}

interface IAdSavingsProps {
  product: IProduct;
  savingsType?: eSavingsType;
}


export const generateSavingsNumber = (originalPrice, salePrice) => Math.round(originalPrice - salePrice);

export const generateSavingsPercent = (originalPrice, salePrice) => Math.abs(Math.floor(percentage.differenceBetween(originalPrice, salePrice)));

/*
<span>{numeral(savings).format("0,0")} {currencyValueToLabel[props.product.saleDetails.currency]}  </span>
 */
const generateSavingsType = (originalPrice, salePrice, currency, savingsType?) => {

  switch (savingsType) {
    case eSavingsType.PERCENTAGE:
      return [generateSavingsPercent(originalPrice, salePrice), "%"].join("");

    case eSavingsType.NUMBER: {
      return [generateSavingsNumber(originalPrice, salePrice), currencyValueToLabel[currency]].join(" ");
    }
  }
  return 0;
};

const generateSavingsLabel = (props) => {
  switch (props.savingsType) {
    case eSavingsType.PERCENTAGE:
      return 'החיסכון שלך'

    case eSavingsType.NUMBER: {
      return "הרווח שלך"
    }
  }
  return "";
}


const AdSavings = (props: IAdSavingsProps) => {
  const originalPrice = extractProductOriginalPrice(props.product);
  const salePrice = props.product.saleDetails.askingPrice;
  const savings = generateSavingsNumber(originalPrice, salePrice);
  return (
    <div className={styles.savings}>
      <If condition={savings > 0}>
        <Then>
          <span>{generateSavingsLabel(props)}:</span>
          &nbsp;
          <span>{generateSavingsType(originalPrice, salePrice, props.product.saleDetails.currency, props.savingsType)}</span>
        </Then>
        <Else>
          <span>&nbsp;</span>
        </Else>
      </If>
    </div>
  );
};

AdSavings.defaultProps = {
  product: {},
  savingsType: eSavingsType.PERCENTAGE,
};
export default AdSavings;
